import { FC, memo } from 'react';
import { FormattedNumber } from 'react-intl';

import {
  getMetricValueCategory,
  getMetricValueDigits,
  getMetricValueUnit,
  MetricValueCategory,
} from 'views/bluviu-nutrition/features/scenarios-v2/utils/format-metric-value';

type Props = {
  value: number | null | undefined;
  category?: MetricValueCategory;
  valueKey?: string;
  currency?: string;
};

const FormatMetricValue: FC<Props> = ({ value, category, valueKey, currency }) => {
  if (!Number.isFinite(value)) return <>{'-'}</>;

  const resolvedCategory = category ?? (valueKey ? getMetricValueCategory(valueKey) : undefined);

  if (!resolvedCategory) {
    return <FormattedNumber value={value as number} />;
  }

  const digits = getMetricValueDigits(resolvedCategory);
  const unit = getMetricValueUnit(resolvedCategory, currency);

  return (
    <>
      <FormattedNumber value={value as number} {...digits} />
      {unit && ` ${unit}`}
    </>
  );
};

export default memo(FormatMetricValue);
